const icon = require('vue-svgicon');
icon.register({
    'cross-round': {
        width: 16,
        height: 16,
        viewBox: '0 0 16 16',
        data: `<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M8 15.11A7.111 7.111 0 118 .89 7.111 7.111 0 018 15.11zM8 1.838a6.163 6.163 0 100 12.326A6.163 6.163 0 008 1.837zm1.608 8.375c.186.185.479.194.653.021.174-.173.165-.463-.021-.648L8.63 7.986l1.609-1.598c.185-.185.195-.475.02-.648-.173-.174-.466-.164-.652.02L8 7.36l-1.608-1.6c-.186-.184-.478-.194-.652-.02-.174.172-.165.463.021.648l1.608 1.598-1.608 1.6c-.186.183-.195.474-.021.647.174.173.466.164.652-.021L8 8.614l1.608 1.598z" _fill="#000"/>`,
    },
});
